import { API_BASE_URL } from "../../config";
import { getAuthHeaders } from "../Auth/authService";
import { scenarioStore } from "./scenarioStore";

const fetchAll = async (): Promise<string[]> =>
{
	const response = await fetch(`${API_BASE_URL}/scenarios`, {
		method: "GET",
		headers: getAuthHeaders(),
	});

	if (!response.ok) throw new Error(response.statusText);

	const data = await response.json();
	const scenarios = data.scenarios || [];
	scenarioStore.set(scenarios);
	return scenarios;
};

const upload = async (file: File): Promise<void> =>
{
	const formData = new FormData();
	formData.append("file", file);

	const response = await fetch(`${API_BASE_URL}/scenarios`, {
		method: "POST",
		headers: {
			"Authorization": sessionStorage.getItem("loginToken") || "",
		},
		body: formData
	});

	if (!response.ok) throw new Error(response.statusText);

	scenarioStore.add(file.name);
};

const remove = async (name: string): Promise<void> =>
{
	const response = await fetch(`${API_BASE_URL}/scenarios/${encodeURIComponent(name)}`, {
		method: "DELETE",
		headers: {
			"Authorization": sessionStorage.getItem("loginToken") || "",
		},
	});

	if (!response.ok) throw new Error(response.statusText);

	scenarioStore.remove(name);
};

export const scenarioService = {
	fetch: fetchAll,
	upload,
	delete: remove,
};
